import React from "react";

const ContactForm = () => {
  return (
    <div className="contact-form-container">
      <div className="heading-title">
        <span>Help Center</span>
      </div>
      <div className="contact-form-border"></div>
      <div className="description">
        <span>
          Reach out by filling out the form. We’ll review your message and
          respond as soon as we can.
        </span>
      </div>
      <div className="help-you-field">
        <input
          className="text-field"
          placeholder="How can we help you?"
        ></input>
        <div className="form-field-container">
          <input className="text-field-half" placeholder="Your Name"></input>
          <input className="text-field-half" placeholder="Your Email"></input>
        </div>
        <div className="form-field-container">
          <input
            className="text-field-half"
            placeholder="(+971) 555-0123"
          ></input>
          <input className="text-field-half" placeholder="Address"></input>
        </div>
        <input className="text-field-message" placeholder="Message"></input>
        <div className="checkbox-container">
          <input type="checkbox"></input>
          <span className="checkbox-title">
            Check here to subscribe for updates.
          </span>
        </div>
      </div>
      <button className="book-now">Book Now</button>
    </div>
  );
};

export default ContactForm;
